export const populateToolbarButtonStore = (editor, store) =>
  Array.from(
    editor.editorContainer.querySelectorAll(
      ".tox-toolbar button,.tox-toolbar *[role='button']",
    ),
  ).forEach((referenceEl, i) => {
    const title = referenceEl.getAttribute("title");
    if (!title) return;

    referenceEl.removeAttribute("title");

    store.update(($toolbarButtons) => {
      $toolbarButtons.push({
        referenceEl,
        hovered: false,
        focused: false,
        title,
      });
      return $toolbarButtons;
    });

    referenceEl.addEventListener("mouseenter", () =>
      store.update(($toolbarButtons) => {
        $toolbarButtons[i].hovered = true;
        return $toolbarButtons;
      }),
    );
    referenceEl.addEventListener("mouseleave", () =>
      store.update(($toolbarButtons) => {
        $toolbarButtons[i].hovered = false;
        return $toolbarButtons;
      }),
    );
    referenceEl.addEventListener("focus", () =>
      store.update(($toolbarButtons) => {
        $toolbarButtons[i].focused = true;
        return $toolbarButtons;
      }),
    );
    referenceEl.addEventListener("blur", () =>
      store.update(($toolbarButtons) => {
        $toolbarButtons[i].focused = false;
        return $toolbarButtons;
      }),
    );

    referenceEl.addEventListener("click", () =>
      store.update(($toolbarButtons) => {
        $toolbarButtons[i].focused = false;
        $toolbarButtons[i].hover = false;
        return $toolbarButtons;
      }),
    );
  });
